export default __webpack_public_path__ + "static/media/map3.ccc4e0d2.png";